// @flow

import * as React from "react"
import { Modal } from "antd"
import IntlStore from "shared/stores/IntlStore"

let modalInstance: typeof Modal

function clearModal() {
  if (modalInstance) modalInstance.destroy()
}

const customMessage = {
  success(content: React.Node) {
    clearModal()
    modalInstance = Modal.success({
      title: IntlStore.formatMessage("common.ok"),
      content
    })
  },
  error(content: React.Node) {
    clearModal()
    modalInstance = Modal.error({
      title: IntlStore.formatMessage("common.error"),
      content
    })
  },
  warning(content: React.Node) {
    clearModal()
    modalInstance = Modal.warning({
      title: IntlStore.formatMessage("common.warning"),
      content
    })
  },
  info(content: React.Node, onOk: Function) {
    clearModal()
    modalInstance = Modal.info({
      title: IntlStore.formatMessage("common.info"),
      content,
      onOk: onOk
    })
  }
}

export default customMessage
